(function() {
  $('.product-template .js-product-page-gallery .gallery-cell').on(
    'click',
    function(e) {
      if (
        $(e.currentTarget)
          .data('title')
          .includes('vimeo.com')
      ) {
        return dataLayer.push({ event: 'videoView' });
      } else {
        return dataLayer.push({ event: 'imageView' });
      }
    }
  );

  var container = $('.recommended-products-container');
  if (container.length > 0) {
    // Get recommended products based on the first cart item ID;
    getRecommendedProducts($(container).data('product-id'));
  }
})();

function setTemplate(item, index) {
  var recommendedProductWrap = $(
    '.recommended-products-container .product-wrap'
  )[index];
  $(recommendedProductWrap)
    .find('.title')
    .text(item.title);
  $(recommendedProductWrap)
    .find('.price')
    .text('$' + (item.price * 0.01).toFixed(2));
  $(recommendedProductWrap)
    .find('.product_image a')
    .attr('href', item.url);
  $(recommendedProductWrap)
    .find('.product-info__caption')
    .attr('href', item.url);
  $(recommendedProductWrap)
    .find('.product_image img.appear')
    .attr('src', item.images[0]);

  if (item.images.length > 1) {
    $(recommendedProductWrap)
      .find('.product_image img.secondary')
      .attr('src', item.images[1]);
  }
}

function getRecommendedProducts(productID) {
  jQuery.getJSON(
    '/recommendations/products.json?product_id=' + productID + '&limit=4',
    function(response) {
      var recommendedProducts = response.products;
      if (recommendedProducts.length > 0) {
        $.each(recommendedProducts, function(index, item) {
          setTemplate(item, index);
        });
      }
    }
  );
}
